import React from 'react';
import Lottie from 'react-lottie';
import lottieData from './aiERP-loader.json';

const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: lottieData,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    }
};

type Props = {
    width?: number;
};
export const AILottieLoader = ({width = 360}: Props) => {
    return <Lottie options={defaultOptions} height={width} width={width} />;
};
